import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const fetchAllBrands = (filters = {}) => {
  const query_string = new URLSearchParams(filters).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/brand?${query_string}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchOneBrand = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/brand/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const createBrand = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/brand/`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const updateBrand = (id, data) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/brand/${id}`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const deleteBrand = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_BASE_URL}/brand/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchBrandTree = (filters = {}) => {
  const query_string = new URLSearchParams(filters).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/brand/tree?${query_string}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};
